<!-- src/app/pages/t0-dashboard/components/t0-stats/t0-stats.component.html -->
<!-- Change ONLY number pipes on values to force 0 decimals -->

<div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-4">
  @if (getCard(0); as c0) {
    <div
      class="bg-surface-0 rounded-2xl shadow-lg px-5 py-4 flex flex-col gap-2"
      [pTooltip]="tooltipTotal || ''"
      [tooltipDisabled]="!(tooltipTotal && tooltipTotal.length)"
      tooltipPosition="top"
      appendTo="body"
      positionStyle="fixed"
      tooltipZIndex="10000"
      [showDelay]="150"
      [hideDelay]="50"
    >
      <span class="text-[10px] font-semibold text-slate-400 uppercase">Total HT Population</span>
      <div class="text-lg font-semibold text-slate-700">
        {{ c0.value | number: '1.0-0' }}
      </div>
      <div class="flex items-center gap-2 mt-1">
        <div class="flex-1 h-1.5 rounded-full bg-slate-100 overflow-hidden">
          <div class="h-1.5 bg-rose-600" [style.width.%]="100"></div>
        </div>
        <span class="text-[11px] font-semibold text-rose-600">100%</span>
      </div>
    </div>
  }

  @if (getCard(1); as c1) {
    <div class="bg-surface-0 rounded-2xl shadow-lg px-5 py-4 flex flex-col gap-2">
      <span class="text-[10px] font-semibold text-slate-400 uppercase">Undiagnosed</span>
      <div class="text-lg font-semibold text-slate-700">{{ c1.value | number: '1.0-0' }}</div>
      <div class="flex items-center gap-2 mt-1">
        <div class="flex-1 h-1.5 rounded-full bg-slate-100 overflow-hidden">
          <div class="h-1.5 bg-rose-600" [style.width.%]="c1.barPercent || 0"></div>
        </div>
        <span class="text-[11px] font-semibold text-rose-600"> {{ c1.percent | number: '1.0-0' }}% </span>
      </div>
    </div>
  }

  @if (getCard(2); as c2) {
    <div class="bg-surface-0 rounded-2xl shadow-lg px-5 py-4 flex flex-col gap-2">
      <span class="text-[10px] font-semibold text-slate-400 uppercase">Diagnosed</span>
      <div class="text-lg font-semibold text-slate-700">{{ c2.value | number: '1.0-0' }}</div>
      <div class="flex items-center gap-2 mt-1">
        <div class="flex-1 h-1.5 rounded-full bg-slate-100 overflow-hidden">
          <div class="h-1.5 bg-rose-600" [style.width.%]="c2.barPercent || 0"></div>
        </div>
        <span class="text-[11px] font-semibold text-rose-600"> {{ c2.percent | number: '1.0-0' }}% </span>
      </div>
    </div>
  }

  @if (getCard(3); as c3) {
    <div class="bg-surface-0 rounded-2xl shadow-lg px-5 py-4 flex flex-col gap-2">
      <span class="text-[10px] font-semibold text-slate-400 uppercase">Treated</span>
      <div class="text-lg font-semibold text-slate-700">{{ c3.value | number: '1.0-0' }}</div>
      <div class="flex items-center gap-2 mt-1">
        <div class="flex-1 h-1.5 rounded-full bg-slate-100 overflow-hidden">
          <div class="h-1.5 bg-rose-600" [style.width.%]="c3.barPercent || 0"></div>
        </div>
        <span class="text-[11px] font-semibold text-rose-600"> {{ c3.percent | number: '1.0-0' }}% </span>
      </div>
    </div>
  }

  @if (getCard(4); as c4) {
    <div class="bg-surface-0 rounded-2xl shadow-lg px-5 py-4 flex flex-col gap-2">
      <span class="text-[10px] font-semibold text-slate-400 uppercase">Controlled</span>
      <div class="text-lg font-semibold text-slate-700">{{ c4.value | number: '1.0-0' }}</div>
      <div class="flex items-center gap-2 mt-1">
        <div class="flex-1 h-1.5 rounded-full bg-slate-100 overflow-hidden">
          <div class="h-1.5 bg-rose-600" [style.width.%]="c4.barPercent || 0"></div>
        </div>
        <span class="text-[11px] font-semibold text-rose-600"> {{ c4.percent | number: '1.0-0' }}% </span>
      </div>
    </div>
  }
</div>